// Module
var code = "<template keyup.delegate=\"onKeyUp($event)\" class.bind=\"clazz\"> <require from=\"./standard-button.scss\"></require> <a click.delegate=\"onClick($event)\" class=\"standard-button\"> <slot name=\"content\"> <span class=\"button-label\"> <slot></slot> </span> </slot> </a> </template> ";
// Exports
export default code;